const settings = {
    viewSettings:{
        changePassword:'تغير كلمة المرور',
        cancellationPolicy:'سياسة الإلغاء',
        mimarConstants:' قيم ميمار '
    },
    cancellationPolicy:{
        cancellationDuration: 'مدة الإلغاء',
        cancelationDurationlabel: 'السماح بالإلغاء قبل الموعد حتى',
        consecutiveCancellations: 'الإلغاءات المتتالية',
        consecutiveCancellationsText:'يسمح للعميل بإلغاء المواعيد المتتالية على التوالي',
        maxNumberOfConsecutiveCancellations: 'الحد الأقصى لعدد الإلغاءات المتتالية',
        numberOfDaysForPreventingFurtherCancelllations: 'عدد الأيام لمنع المزيد من الإلغاءت',
        days: 'أيام',
        hours:'ساعات',
        hoursPlaceholders: 'ادخل عدد الساعات',
        maxNumberPlaceholder: 'ادخل الحد الأقصى من الإلغاءات المتتالية',
        daysPlaceholder: 'ادخل عدد الأيام',
        hint: '   وسيُسمح للعميل بإلغاء المواعيد المتتالية حتى هذا الحد دون استكمال أي موعد بينهما ويجب أن يبدأ هذا الحد من 2 ',
        maxNumberErrorMsg: 'يجب أن يبدأ الحد الأقصى لعدد الإلغاءات المتتالية من 2',
       
    },
    changePassword:{
        changePassword:'تغير كلمة المرور'
    },
    mimarConstants:{
        vat: 'ضريبة القيمة المضافة %',
        onlineFees: 'الرسوم الإلكترونية %',
        mimarCommission: 'عمولة ميمار %',
        vatPlaceholder: 'ادخل ضريبة القيمة المضافة',
        onlineFeesPlaceholder: 'ادخل الرسوم الإلكترونية',
        mimarCommissionPlaceholder: 'ادخل عمولة ميمار',
        fixedFees:"الرسوم ثابتة",
        commissionStartsAfter:"العولة تبدأ بعد",
        fixedFeesPlaceholder:"ادخل الرسوم الثابتة",
        commissionStartsAfterPlaceholder:"ادخل العمولة تبدأ بعد كم موعد",
        completedPaidAppointments:"المواعيد المكتملة والمدفوعة",
    }
    


};

export default settings;